import PublicAPI from '@/api/TreedisPublicDAO';
import { getDeviceFingerprint } from '@/utils/index';

export const logoutHandler = async ({
  ticket,
  ticketingOrderedTicket,
}: {
  ticket?: any;
  ticketingOrderedTicket?: any;
}) => {
  if (ticket && ticketingOrderedTicket && ticketingOrderedTicket.ticketType === 'tourByYourself') {
    await PublicAPI.logoutTicket({
      ticketId: ticketingOrderedTicket?.id,
      deviceId: getDeviceFingerprint(),
    });
  }
};
